import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { authAPI } from '../services/api';
import { setToken } from '../utils/auth';

const LoginPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const [isRegister, setIsRegister] = useState(false);
  const [username, setUsername] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (isRegister) {
        const { data } = await authAPI.register({ username, email, password });
        setToken(data.token);
        navigate('/home');
      } else {
        const { data } = await authAPI.login({ email_or_username: email, password });
        setToken(data.token);
        navigate('/home');
      }
    } catch (error) {
      alert((isRegister ? 'Registration' : 'Login') + ' failed: ' + (error.response?.data?.detail || 'Invalid credentials'));
    }
  };

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: 'linear-gradient(135deg, #0f172a 0%, #1e1b4b 50%, #0f172a 100%)' }}>
      {/* Left Section - Login Form */}
      <motion.div
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          padding: '48px',
          maxWidth: '600px'
        }}
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6 }}
      >
        {/* Logo */}
        <div style={{ marginBottom: '48px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div style={{ width: '40px', height: '40px', background: 'linear-gradient(135deg, #a855f7, #3b82f6)', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <svg style={{ width: '24px', height: '24px' }} viewBox="0 0 512 512" fill="white">
                <path d="M362.667,170.667c-29.867,0-57.6,10.667-79.467,28.8L256,224l-27.2-24.533c-21.867-18.133-49.6-28.8-79.467-28.8
                  C66.133,170.667,0,236.8,0,320s66.133,149.333,149.333,149.333c29.867,0,57.6-10.667,79.467-28.8L256,416l27.2,24.533
                  c21.867,18.133,49.6,28.8,79.467,28.8C445.867,469.333,512,403.2,512,320S445.867,170.667,362.667,170.667z M149.333,426.667
                  C91.733,426.667,42.667,377.6,42.667,320s49.067-106.667,106.667-106.667c23.467,0,45.867,8.533,62.933,23.467L256,277.333
                  l-43.733,40.533c-17.067,14.933-39.467,23.467-62.933,23.467V426.667z M362.667,426.667c-23.467,0-45.867-8.533-62.933-23.467
                  L256,362.667l43.733-40.533c17.067-14.933,39.467-23.467,62.933-23.467c57.6,0,106.667,49.067,106.667,106.667
                  S420.267,426.667,362.667,426.667z"/>
              </svg>
            </div>
            <span style={{ fontSize: '24px', fontWeight: 'bold', color: 'white' }}>DeployCREW</span>
          </div>
        </div>

        {/* Login Form */}
        <div>
          <h1 style={{ fontSize: '32px', fontWeight: 'bold', color: 'white', marginBottom: '32px' }}>
            {isRegister ? 'Create your account' : 'Sign in to your account'}
          </h1>

          <form onSubmit={handleSubmit}>
            {isRegister && (
              <div style={{ marginBottom: '24px' }}>
                <label htmlFor="username" style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#d1d5db', marginBottom: '8px' }}>
                  Username
                </label>
                <input
                  id="username"
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    background: 'rgba(255, 255, 255, 0.05)',
                    border: '1px solid rgba(255, 255, 255, 0.1)',
                    borderRadius: '8px',
                    color: 'white',
                    fontSize: '16px',
                    outline: 'none',
                    transition: 'all 0.3s'
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#a855f7'}
                  onBlur={(e) => e.target.style.borderColor = 'rgba(255, 255, 255, 0.1)'}
                />
              </div>
            )}
            {/* Email Input */}
            <div style={{ marginBottom: '24px' }}>
              <label htmlFor="email" style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#d1d5db', marginBottom: '8px' }}>
                {isRegister ? 'Email Address' : 'Email Address / Username'}
              </label>
              <input
                id="email"
                type="text"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                style={{
                  width: '100%',
                  padding: '12px 16px',
                  background: 'rgba(255, 255, 255, 0.05)',
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                  borderRadius: '8px',
                  color: 'white',
                  fontSize: '16px',
                  outline: 'none',
                  transition: 'all 0.3s'
                }}
                onFocus={(e) => e.target.style.borderColor = '#a855f7'}
                onBlur={(e) => e.target.style.borderColor = 'rgba(255, 255, 255, 0.1)'}
              />
            </div>

            {/* Password Input */}
            <div style={{ marginBottom: '8px' }}>
              <label htmlFor="password" style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#d1d5db', marginBottom: '8px' }}>
                Password
              </label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                style={{
                  width: '100%',
                  padding: '12px 16px',
                  background: 'rgba(255, 255, 255, 0.05)',
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                  borderRadius: '8px',
                  color: 'white',
                  fontSize: '16px',
                  outline: 'none',
                  transition: 'all 0.3s'
                }}
                onFocus={(e) => e.target.style.borderColor = '#a855f7'}
                onBlur={(e) => e.target.style.borderColor = 'rgba(255, 255, 255, 0.1)'}
              />
            </div>

            {/* Forgot Password Link */}
            <div style={{ textAlign: 'right', marginBottom: '24px' }}>
              <a
                href="#"
                style={{
                  color: '#a855f7',
                  fontSize: '14px',
                  textDecoration: 'none',
                  transition: 'color 0.3s'
                }}
                onMouseEnter={(e) => e.target.style.color = '#c084fc'}
                onMouseLeave={(e) => e.target.style.color = '#a855f7'}
              >
                Forgot your password?
              </a>
            </div>

            {/* Login Button */}
            <motion.button
              type="submit"
              style={{
                width: '100%',
                padding: '14px',
                background: 'linear-gradient(90deg, #9333ea, #2563eb)',
                border: 'none',
                borderRadius: '8px',
                color: 'white',
                fontSize: '16px',
                fontWeight: '600',
                cursor: 'pointer',
                marginBottom: '16px'
              }}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              {isRegister ? 'Register' : 'Sign in'}
            </motion.button>

            {/* Register Link */}
            <div style={{ textAlign: 'center' }}>
              <span style={{ color: '#9ca3af', fontSize: '14px' }}>
                {isRegister ? 'Already have an account? ' : 'Do not have an account? '}
              </span>
              <a
                href="#"
                onClick={(e) => { e.preventDefault(); setIsRegister(!isRegister); }}
                style={{
                  color: '#a855f7',
                  fontSize: '14px',
                  textDecoration: 'none',
                  fontWeight: '600',
                  transition: 'color 0.3s'
                }}
                onMouseEnter={(e) => e.target.style.color = '#c084fc'}
                onMouseLeave={(e) => e.target.style.color = '#a855f7'}
              >
                {isRegister ? 'Sign in' : 'Register'}
              </a>
            </div>
          </form>
        </div>
      </motion.div>

      {/* Right Section - Content Panel */}
      <motion.div
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '48px',
          background: 'rgba(255, 255, 255, 0.02)',
          backdropFilter: 'blur(10px)',
          borderLeft: '1px solid rgba(255, 255, 255, 0.1)'
        }}
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6, delay: 0.2 }}
      >
        {/* Illustration */}
        <motion.div
          style={{
            width: '300px',
            height: '300px',
            marginBottom: '48px',
            background: 'linear-gradient(135deg, rgba(168, 85, 247, 0.2), rgba(59, 130, 246, 0.2))',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            overflow: 'hidden'
          }}
          animate={{
            scale: [1, 1.05, 1],
          }}
          transition={{
            duration: 4,
            repeat: Infinity,
            ease: 'easeInOut'
          }}
        >
          {/* DevOps Illustration */}
          <svg style={{ width: '200px', height: '200px' }} viewBox="0 0 200 200" fill="none">
            {/* Pipeline Flow */}
            <circle cx="50" cy="100" r="20" fill="#a855f7" opacity="0.8"/>
            <circle cx="100" cy="100" r="20" fill="#3b82f6" opacity="0.8"/>
            <circle cx="150" cy="100" r="20" fill="#10b981" opacity="0.8"/>
            <line x1="70" y1="100" x2="80" y2="100" stroke="white" strokeWidth="3"/>
            <line x1="120" y1="100" x2="130" y2="100" stroke="white" strokeWidth="3"/>
            {/* Arrows */}
            <polygon points="80,95 80,105 85,100" fill="white"/>
            <polygon points="130,95 130,105 135,100" fill="white"/>
          </svg>
        </motion.div>

        {/* Content Text */}
        <div style={{ textAlign: 'center', maxWidth: '500px' }}>
          <h2 style={{ fontSize: '36px', fontWeight: 'bold', color: 'white', marginBottom: '16px' }}>
            Visually Build CI/CD Pipelines
          </h2>
          <p style={{ fontSize: '18px', color: '#9ca3af', lineHeight: 1.6 }}>
            The only CI/CD engine to visually design and control your cross-environments deployment strategies without YAML.
          </p>
        </div>
      </motion.div>

      {/* Responsive Styles */}
      <style>{`
        @media (max-width: 768px) {
          div[style*="display: flex"] {
            flex-direction: column !important;
          }
        }
      `}</style>
    </div>
  );
};

export default LoginPage;
